import 'angular-strap/dist/modules/collapse';
import 'angular-strap/dist/modules/dimensions';
import 'angular-strap/dist/modules/modal';
import 'angular-strap/dist/modules/modal.tpl';
import 'angular-strap/dist/modules/parse-options';
import 'angular-strap/dist/modules/popover';
import 'angular-strap/dist/modules/popover.tpl';
import 'angular-strap/dist/modules/raf';
import 'angular-strap/dist/modules/select';
import 'angular-strap/dist/modules/select.tpl';
import 'angular-strap/dist/modules/dropdown';
import 'angular-strap/dist/modules/dropdown.tpl';
import 'angular-strap/dist/modules/typeahead';
import 'angular-strap/dist/modules/typeahead.tpl';
import 'angular-strap/dist/modules/tooltip';
import 'angular-strap/dist/modules/tooltip.tpl';

export default angular.module('doxy.angular-strap.base', [
  'mgcrea.ngStrap.collapse',
  'mgcrea.ngStrap.modal',
  'mgcrea.ngStrap.popover',
  'mgcrea.ngStrap.select',
  'mgcrea.ngStrap.dropdown',
  'mgcrea.ngStrap.tooltip',
  'mgcrea.ngStrap.typeahead',
  'mgcrea.ngStrap.helpers.parseOptions',
]).name;
